import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/authService';

interface PermissionGateProps {
  children: React.ReactNode;
  requireSuperAdmin?: boolean;
  requireTenantAdmin?: boolean;
  fallback?: React.ReactNode;
}

const PermissionGate: React.FC<PermissionGateProps> = ({
  children,
  requireSuperAdmin = false,
  requireTenantAdmin = false,
  fallback = null
}) => {
  const { isAuthenticated, isSuperAdmin, user } = useAuth();

  // 未认证用户不显示任何内容
  if (!isAuthenticated) {
    return <>{fallback}</>;
  }

  // 需要超级管理员权限但用户不是超级管理员
  if (requireSuperAdmin && !isSuperAdmin) {
    return <>{fallback}</>;
  }

  // 需要租户管理员权限但用户不是租户管理员
  if (requireTenantAdmin && !authService.isTenantAdmin()) {
    return <>{fallback}</>;
  }

  return <>{children}</>;
};

export default PermissionGate;
